export const cilVolumeLow = ["24 24","<path d='M15 7.875v1.5c1.45 0 2.625 1.175 2.625 2.625s-1.175 2.625-2.625 2.625v0 1.5c2.278 0 4.125-1.847 4.125-4.125s-1.847-4.125-4.125-4.125v0z'></path><path d='M6.814 5.625h-6.064v12.75h6.064l4.875 4.875h1.811v-22.5h-1.811zM6 16.875h-3.75v-9.75h3.75zM12 21.439l-4.5-4.5v-9.878l4.5-4.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-volume-low.js
// module id = null
// module chunks = 